import { TabDTO } from "utils/domain/mediaView/tabDTO";
import { ExternalTabsService } from "./externalTabsService";

export interface ApiExternalTabsService {
     GetExternalTabs(companyRef: string, sessionId: string): Promise<TabDTO[]>;
}

export const externalTabsSocket = new ExternalTabsService();